import useAxios from "../../../Hooks/useAxios";
import { useEffect, useState } from "react";
import {
  FiUser,
  FiCalendar,
  FiBox,
  FiCoffee,
  FiHash,
  FiClipboard,
} from "react-icons/fi";

function Prescription({ visits = [] }) {
  const [prescriptionByVisit, setPrescriptionByVisit] = useState({});
  const request = useAxios();

  const safe = (value) => value ?? "—";

  const formatDate = (date) => {
    if (!date) return "—";
    return new Date(date).toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getPrescription = async () => {
    if (!visits?.length) return;
    const visitIds = visits.map((v) => v?.id).filter(Boolean);
    if (!visitIds.length) return;

    const res = await request({
      method: "GET",
      url: "chapchap/list/visit_prescription",
      params: { "visit_id-int": visitIds.join(",") },
      showSuccessModal: false,
      showLoadingModal: false,
    });

    if (!res?._error && res?.data?.docs?.length) {
      const grouped = res.data.docs.reduce((acc, p) => {
        const vid = p?.visit_id ?? "unknown";
        if (!acc[vid]) acc[vid] = [];
        acc[vid].push(p);
        return acc;
      }, {});
      setPrescriptionByVisit(grouped);
    }
  };

  useEffect(() => {
    getPrescription();
  }, [visits]);

  if (!Object.keys(prescriptionByVisit).length) {
    return (
      <div className="p-5 text-center text-auro_metal_saurus">
        No prescription history available.
      </div>
    );
  }

  return (
    <div className="w-full p-5 flex flex-col gap-6">
      <h2 className="text-2xl font-bold text-yankees_blue mb-4">
        Patient Prescription History
      </h2>

      {/* Display all prescriptions in 2 columns using flexbox */}
      <div className="flex flex-wrap gap-6">
        {Object.entries(prescriptionByVisit).map(([visitId, prescriptions]) =>
          prescriptions.map((p) => (
            <div
              key={p.id}
              className="flex-1 min-w-[48%] bg-white shadow-xl rounded-3xl p-6 border border-bright_grey"
            >
              <div className="mb-4 flex justify-between items-center border-b border-bright_grey pb-2">
                <h3 className="text-lg font-semibold text-yankees_blue">
                  {safe(p?.consumables?.inventory_items?.name)}
                </h3>
                <span className="text-auro_metal_saurus text-sm">
                  Visit Date: {formatDate(p?.created_at)}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-2">
                <Detail
                  label="Frequency"
                  value={safe(p?.frequency)}
                  icon={<FiHash />}
                />
                <Detail
                  label="Food Relation"
                  value={safe(p?.food_relation)}
                  icon={<FiCoffee />}
                />
                <Detail
                  label="No of Days"
                  value={safe(p?.no_of_day)}
                  icon={<FiCalendar />}
                />
                <Detail
                  label="Total Qty"
                  value={safe(p?.qty)}
                  icon={<FiBox />}
                />
                <Detail
                  label="Requested By"
                  value={safe(
                    p?.team_visit_prescription_requested_byToteam?.name
                  )}
                  icon={<FiUser />}
                />
                <Detail
                  label="Given By"
                  value={safe(
                    p?.team_visit_prescription_performed_byToteam?.name
                  )}
                  icon={<FiUser />}
                />
                {p?.comments && (
                  <Detail
                    label="Comments"
                    value={safe(p.comments)}
                    icon={<FiClipboard />}
                  />
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const Detail = ({ label, value, icon }) => (
  <div className="flex items-center gap-2 bg-white rounded-lg p-2 border border-bright_grey">
    <span className="text-primary text-lg">{icon}</span>
    <div>
      <div className="text-sm text-auro_metal_saurus">{label}</div>
      <div className="font-semibold text-yankees_blue">{value}</div>
    </div>
  </div>
);

export default Prescription;
